import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import erpCommentService from "services/common/ErpCommentService";

export const GetAllGiftChat = createAsyncThunk(
  "erpComment/GetAllGiftChat",
  async (data, { rejectWithValue }) => {
    try {
      const response = await erpCommentService.getAllGiftChat(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const AddNewErpComment = createAsyncThunk(
  "erpComment/AddNewErpComment",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, ...payload } = data;
      const response = await erpCommentService.addComment(payload);
      if (onSuccess) {
        onSuccess();
      }
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const ReadAllErpComment = createAsyncThunk(
  "erpComment/ReadAllErpComment",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const response = await erpCommentService.readAll(id);
      if (onSuccess) {
        onSuccess();
      }
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetBcDoanhThuKskTheoChucDanh = createAsyncThunk(
  "erpComment/GetBcDoanhThuKskTheoChucDanh",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await erpCommentService.GetBcDoanhThuKskTheoChucDanh(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  data: {},
  ListBcDoanhThuKskTheoChucDanh: []
};

const erpCommentSlice = createSlice({
  name: "erpComment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //GetBcDoanhThuKskTheoChucDanh
    builder.addCase(GetBcDoanhThuKskTheoChucDanh.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(GetBcDoanhThuKskTheoChucDanh.fulfilled, (state, action) => {
      state.loading = false;
      state.ListBcDoanhThuKskTheoChucDanh = action.payload;
    });
    builder.addCase(GetBcDoanhThuKskTheoChucDanh.rejected, (state, action) => {
      state.loading = false;
    });
    //GetAllGiftChat
    builder.addCase(GetAllGiftChat.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(GetAllGiftChat.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(GetAllGiftChat.rejected, (state, action) => {
      state.loading = false;
    })
      ;
  },
});

export default erpCommentSlice.reducer;
